import { Link } from 'react-router';

/**
 * Catch-all 404. Renders for any URL the React Router doesn't have a
 * registered route for (e.g. /app/admin/ with no sub-path, or stale
 * deep links).
 *
 * Deliberately plain — no DashboardLayout chrome around it, no session
 * fetch. A 404 should be instantly informative without imposing any
 * extra requests or layout setup.
 */
export default function NotFound() {
  return (
    <main className="mx-auto flex min-h-screen max-w-xl flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="font-display text-7xl font-bold tracking-tight text-[var(--color-on-surface-variant)]">
        404
      </div>
      <h1 className="font-display text-2xl font-bold tracking-tight">
        Page not found
      </h1>
      <p className="text-[var(--color-on-surface-variant)]">
        This URL doesn&apos;t resolve to anything we serve. The link may be
        stale, mistyped, or part of an internal route you don&apos;t have
        access to.
      </p>
      <div className="mt-2 flex flex-wrap items-center justify-center gap-3 text-sm">
        <Link
          to="/app"
          className="rounded-full bg-[var(--color-primary)] px-5 py-2 font-medium text-[var(--color-primary-foreground)] transition hover:brightness-110"
        >
          Back to dashboard
        </Link>
        <Link
          to="/"
          className="text-[var(--color-on-surface-variant)] underline-offset-4 hover:text-[var(--color-foreground)] hover:underline"
        >
          Marketing site
        </Link>
      </div>
    </main>
  );
}
